import React from 'react';
import propTypes from 'prop-types';
import SnackBarAlerts from '../../../../../../../common/snackBarAlerts/snackBarAlerts';

const ImageUploadStatus = (props) => {
  const { imageUploadFailed, snackBarMessage, handleCloseSnackBar } = props;

  return (
    <>
      {imageUploadFailed && (
        <SnackBarAlerts
          showSnackBar
          snackBarType="error"
          snackBarMessage={snackBarMessage}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          handleClose={handleCloseSnackBar}
        />
      )}
    </>
  );
};

ImageUploadStatus.propTypes = {
  snackBarMessage: propTypes.string.isRequired,
  handleCloseSnackBar: propTypes.func.isRequired,
  imageUploadFailed: propTypes.func.isRequired,
};

export default ImageUploadStatus;
